import React from "react";

import LoadingBar from "Cobalt/LoadingBar";
import { SizeSwitch } from "Common/Responsive";
import { Card, CardHeader, CardSection } from "Theme/Card";

import makeBem from "Utils/makeBem";

const bem = makeBem("QuotePagePlanCard");

const LoadingPlanCard = () => (
  <Card data-testid="PlanCard" data-title="Loading Curently Enrolled Plan" theme="elevated" className={bem()}>
    <SizeSwitch
      xs={
        <>
          <CardSection p={4} className={bem("Summary")}>
            <LoadingBar ariaText="Loading Curently Enrolled Plan" />
            <LoadingBar />
          </CardSection>
          <CardSection p={4} className={bem("Summary")}>
            <LoadingBar />
            <LoadingBar />
            <LoadingBar />
          </CardSection>
        </>
      }
      sm={
        <>
          <CardHeader p={3} className={bem("Header")}>
            <LoadingBar ariaText="Loading Curently Enrolled Plan" />
            <LoadingBar />
          </CardHeader>
          <CardSection p={4} className={bem("Summary")}>
            <LoadingBar />
            <LoadingBar mx="auto" />
            <LoadingBar />
          </CardSection>
        </>
      }
    />
  </Card>
);

export default LoadingPlanCard;
